import { action, createRequestTypes } from '../base';

export const cfV2ActionTypes = {
  GET_CFV2: createRequestTypes('GET_CFV2'),
  GET_CFV2_GLOBAL: createRequestTypes('GET_CFV2_GLOBAL'),
  GET_CFV2_BY_ID: createRequestTypes('GET_CFV2_BY_ID'),
  CREATE_CFV2: createRequestTypes('CREATE_CFV2'),
  UPDATE_CFV2: createRequestTypes('UPDATE_CFV2'),
  DELETE_CFV2: createRequestTypes('DELETE_CFV2'),
  GET_DOC_CFV2: createRequestTypes('GET_DOC_CFV2'),
};


class CFV2Actions {

  getCFV2 = (payload, callback) => action(cfV2ActionTypes.GET_CFV2.REQUEST, {
    payload, callback,
  })


  getCFV2Loading = (getCFV2Loading, entityType) => action(cfV2ActionTypes.GET_CFV2.LOADING, {
    getCFV2Loading,
    entityType,
  })


  getCFV2Success = (customFieldsV2, entityType) => action(cfV2ActionTypes.GET_CFV2.SUCCESS, {
    customFieldsV2,
    entityType,
  })

  getCfGlobalSuccess = (cfGlobal) => action(cfV2ActionTypes.GET_CFV2_GLOBAL.SUCCESS, {
    cfGlobal,
  })


  getCFV2ById = (orgId, cfV2Id) => action(cfV2ActionTypes.GET_CFV2_BY_ID.REQUEST, {
    orgId, cfV2Id,
  })


  getCFV2ByIdLoading = (getCFV2ByIdLoading) => action(cfV2ActionTypes.GET_CFV2_BY_ID.LOADING, {
    getCFV2ByIdLoading,
  })

  getCFV2ByIdSuccess = (selectedCFV2) => action(cfV2ActionTypes.GET_CFV2_BY_ID.SUCCESS, {
    selectedCFV2,
  })


  createCFV2 = (payload, callback) => action(cfV2ActionTypes.CREATE_CFV2.REQUEST, {
    payload,
    callback,
  })


  createCFV2Loading = (createCFV2Loading) => action(cfV2ActionTypes.CREATE_CFV2.LOADING, {
    createCFV2Loading,
  })


  updateCFV2 = (payload, callback) => action(cfV2ActionTypes.UPDATE_CFV2.REQUEST, {
    payload,
    callback,
  })


  updateCFV2Loading = (updateCFV2Loading) => action(cfV2ActionTypes.UPDATE_CFV2.LOADING, {
    updateCFV2Loading,
  })


  deleteCFV2 = (orgId, cfV2Id, callback) => action(cfV2ActionTypes.DELETE_CFV2.REQUEST, {
    orgId, cfV2Id, callback,
  })


  deleteCFV2Loading = (deleteCFV2Loading) => action(cfV2ActionTypes.DELETE_CFV2.LOADING, {
    deleteCFV2Loading,
  })

  getDocCFV2 = (payload, callback) => action(cfV2ActionTypes.GET_DOC_CFV2.REQUEST, {
    payload, callback,
  })

  getDocCFV2Loading = (getDocCFV2Loading, entityName) => action(cfV2ActionTypes.GET_DOC_CFV2.LOADING, {
    getDocCFV2Loading,
    entityName,
  })

  getDocCFV2Success = (customFieldsDocV2, entityName) => action(cfV2ActionTypes.GET_DOC_CFV2.SUCCESS, {
    customFieldsDocV2,
    entityName,
  })
}

export default new CFV2Actions();
